import { getAiSummaries, saveAiSummaries } from "../../services/inspectionService";
import { setAiSummaries, setLoading, setError, setUpdateLoading, setUpdateError, setUpdateSuccess } from "../slices/aiSummarySlice";
import { AppThunk } from "../store";

export const fetchAiSummaries = (inspectionId: string): AppThunk => async (dispatch) => {
    dispatch(setError(false));
    dispatch(setLoading(true));

    try {
        const response = await getAiSummaries(inspectionId.toLowerCase());

        if (response) {
            dispatch(setAiSummaries(response));
        } else {
            dispatch(setAiSummaries([]));
        }
    } catch (error) {
        console.error(error);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
};

export const updateAiSummaries = (inspectionNumber: string, updates: Record<string, string>, sectionKey: string): AppThunk =>
  async (dispatch) => {
    dispatch(setUpdateError(false));
    dispatch(setUpdateLoading({ sectionKey, loading: true }));

    try {
      await saveAiSummaries(inspectionNumber, updates);
      dispatch(setUpdateSuccess());
    } catch (e) {
      console.error(e);
      dispatch(setUpdateError(true));
    } finally {
      dispatch(setUpdateLoading({ sectionKey, loading: false }));
    }
};
